var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"ntm__header-c"},[_c('NotificationCardIcon',{attrs:{"icon":_vm.cardIcon}}),_c('NotificationCardTitle',{attrs:{"text":_vm.cardTitle}}),_c('NotificationCardSubtitle',{attrs:{"text":_vm.cardSubtitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }